module.exports = __webpack_public_path__ + "img/old-salia.853b4b28.jpg";